import { render, staticRenderFns } from "./InterestOnly.vue?vue&type=template&id=a5a27d5a"
import script from "./InterestOnly.vue?vue&type=script&lang=js"
export * from "./InterestOnly.vue?vue&type=script&lang=js"
import style0 from "./InterestOnly.vue?vue&type=style&index=0&id=a5a27d5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports